import React from 'react';
import { ArrowLeft, ShieldCheck, Lock, Eye, FileText } from "lucide-react";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-neutral-50 font-body py-12 px-6 pt-32">
      <div className="max-w-3xl mx-auto">
        {/* Botón Volver */}
        <a href="/" className="inline-flex items-center text-emerald-800 hover:text-emerald-600 mb-8 font-medium transition-colors">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver a la página principal
        </a>

        <header className="mb-12">
          <h1 className="font-heading font-bold text-4xl text-slate-900 mb-4">Política de Privacidad</h1>
          <p className="text-slate-600">Última actualización: Abril 2026</p>
        </header>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-700">
          
          <section className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <ShieldCheck className="w-6 h-6 text-emerald-800" />
              <h2 className="text-xl font-bold text-slate-900 m-0">1. Responsable del Tratamiento</h2>
            </div>
            <p>
              El responsable del tratamiento de tus datos es <strong>Aller Software Factory</strong> (en adelante, "Nosotros"), con domicilio en [Tu Ciudad, España] y correo electrónico de contacto: <strong>adrianaragongarrote@gmail.com</strong>.
            </p>
          </section>

          <section>
            <div className="flex items-center gap-3 mb-4">
              <Eye className="w-6 h-6 text-emerald-800" />
              <h2 className="text-xl font-bold text-slate-900">2. Datos que Recopilamos</h2>
            </div>
            <p>
              A través de nuestro formulario de lista de espera, recopilamos los siguientes datos de carácter personal:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Nombre y apellidos.</li>
              <li>Nombre del establecimiento gastronómico.</li>
              <li>Dirección de correo electrónico.</li>
            </ul>
          </section>

          <section>
            <div className="flex items-center gap-3 mb-4">
              <FileText className="w-6 h-6 text-emerald-800" />
              <h2 className="text-xl font-bold text-slate-900">3. Finalidad del Tratamiento</h2>
            </div>
            <p>Tratamos tus datos con las siguientes finalidades:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Gestionar tu suscripción a la lista de espera de <strong>Aller Food Control</strong>.</li>
              <li>Informarte sobre el lanzamiento del producto y actualizaciones relevantes.</li>
              <li>Enviarte ofertas exclusivas por ser suscriptor anticipado (Beta).</li>
            </ul>
          </section>

          <section>
            <div className="flex items-center gap-3 mb-4">
              <Lock className="w-6 h-6 text-emerald-800" />
              <h2 className="text-xl font-bold text-slate-900">4. Legitimación y Conservación</h2>
            </div>
            <p>
              La base legal para el tratamiento de tus datos es tu <strong>consentimiento explícito</strong> al marcar la casilla en nuestro formulario. 
              Mantendremos tus datos mientras dure nuestra relación comercial o hasta que solicites su supresión.
            </p>
          </section>

          <section className="bg-emerald-50 p-6 rounded-2xl border border-emerald-100">
            <h2 className="text-xl font-bold text-emerald-900 mb-4">5. Tus Derechos</h2>
            <p className="mb-4">
              Tienes derecho a acceder, rectificar, suprimir tus datos, así como otros derechos explicados en la normativa vigente. 
              Para ejercerlos, puedes enviarnos un correo a <strong>adrianaragongarrote@gmail.com</strong> adjuntando copia de tu DNI o documento equivalente.
            </p>
            <p className="text-sm italic text-emerald-700">
              Si consideras que tus derechos no han sido debidamente atendidos, tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD).
            </p>
          </section>

        </div>

        <footer className="mt-16 pt-8 border-t border-slate-200 text-center text-slate-500 text-sm">
          © 2026 Aller Software Factory. Cumpliendo con el RGPD (UE) 2016/679.
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPage;